import React from 'react';
import { connect } from 'react-redux';

import BankLinkDisclaimerModal from '../BankLink/BankLinkDisclaimerModal';

const MODAL_COMPONENTS = {
  BANK_LINK_DISCLAIMER_MODAL: BankLinkDisclaimerModal,
};

const ModalContainer = (state) => {
  const { modalType } = state;
  if (!modalType) {
    return null; // <React.Fragment />;
  }
  const SpecificModal = MODAL_COMPONENTS[modalType];
  return <SpecificModal />;
};

const mapStateToProps = state => ({
  modalType: state.modals.modalType,
});

export default connect(mapStateToProps)(ModalContainer);



// WEBPACK FOOTER //
// ./src/components/BaseModal/ModalContainer.js